import { render, staticRenderFns } from "./LeaderboardsView.vue?vue&type=template&id=f42449a0&"
import script from "./LeaderboardsView.vue?vue&type=script&lang=js&"
export * from "./LeaderboardsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports